import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import SignupPage from "@/pages/SignupPage";
import CustomerBookingPage from "@/pages/CustomerBookingPage";
import DigitalTicketPage from "@/pages/DigitalTicketPage";
import LiveTVPage from "@/pages/LiveTVPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import HistoryPage from "@/pages/HistoryPage";
import SuperAdminPage from "@/pages/SuperAdminPage";
import DiagnosticsPage from "@/pages/DiagnosticsPage";
import { DEMO_SHOP_SLUG } from "@/lib/supabase";
import { getSubdomainSlug } from "@/lib/tenant";

function App() {
  const subSlug = getSubdomainSlug();

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Root ALWAYS shows the Home Dashboard, even on a subdomain.
              Short paths /book, /tv, /admin, /history map to the subdomain's shop. */}
          <Route path="/" element={<LandingPage />} />
          {subSlug && (
            <>
              <Route path="/book" element={<Navigate to={`/s/${subSlug}/book`} replace />} />
              <Route path="/tv" element={<Navigate to={`/s/${subSlug}/tv`} replace />} />
              <Route path="/admin" element={<Navigate to={`/s/${subSlug}/admin`} replace />} />
              <Route path="/history" element={<Navigate to={`/s/${subSlug}/history`} replace />} />
            </>
          )}
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/super-admin" element={<SuperAdminPage />} />
          <Route path="/diagnostics" element={<DiagnosticsPage />} />
          <Route path="/demo" element={<Navigate to={`/s/${DEMO_SHOP_SLUG}/book`} replace />} />
          <Route path="/s/:slug" element={<RedirectToBook />} />
          <Route path="/s/:slug/book" element={<CustomerBookingPage />} />
          <Route path="/s/:slug/ticket/:tokenNumber" element={<DigitalTicketPage />} />
          <Route path="/s/:slug/tv" element={<LiveTVPage />} />
          <Route path="/s/:slug/admin" element={<AdminDashboardPage />} />
          <Route path="/s/:slug/history" element={<HistoryPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

function RedirectToBook() {
  const slug = window.location.pathname.split("/")[2];
  return <Navigate to={`/s/${slug}/book`} replace />;
}

export default App;
